import type { Sprint as SprintEntity } from 'api/sprint-planning/types';
import type { Task } from 'data/tasks';

export enum PhaseEntityType {
  Task = 'TASK',
  Sprint = 'SPRINT',
}

export function isTask(entity: {
  taskId?: number;
  sprintId?: number;
}): entity is Task {
  return typeof (entity as Task).taskId === 'number';
}

export function isSprint(entity: {
  taskId?: number;
  sprintId?: number;
}): entity is SprintEntity {
  return typeof (entity as SprintEntity).sprintId === 'number';
}

export function extractId(entityId: string) {
  const lastUnderscoreIndex = entityId.lastIndexOf('_');
  const idString = entityId.substring(lastUnderscoreIndex + 1);

  return parseInt(idString, 10);
}

export function extractParts(entityId: string) {
  const parts = entityId.split('_');

  const entityType = parts.slice(0, -1).join('_') as PhaseEntityType;
  const id = parseInt(parts[parts.length - 1], 10);

  return { entityType, id };
}

export function converToEntityId(id: number, entityType: PhaseEntityType) {
  return `${entityType}_${id}`;
}

export function convertKeyToEntityId(key: string) {
  const lastDashIndex = key.lastIndexOf('-');
  const entityId = `${key.substring(0, lastDashIndex)}_${key.substring(
    lastDashIndex + 1,
  )}`;

  return entityId;
}
